import { render } from "./EventsControlPanel.vue?vue&type=template&id=a1888f44"
import script from "./EventsControlPanel.vue?vue&type=script&lang=js"
export * from "./EventsControlPanel.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__